/**
 * @generated SignedSource<<272120c27524e95b9f6ad4726c1247c8>>
 * @relayHash bebb1374303a6344b6c6b1854752f440
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4977ff928289c935ac9557ae1cdfc3e1a41321e9efd62196553dd455dc88c4e6

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiExperimentCoordinatorEndOfTrialExtensionQuery } from './uiExperimentCoordinatorEndOfTrialExtensionQuery.graphql';

const node: PreloadableConcreteRequest<uiExperimentCoordinatorEndOfTrialExtensionQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "4977ff928289c935ac9557ae1cdfc3e1a41321e9efd62196553dd455dc88c4e6",
    "metadata": {},
    "name": "uiExperimentCoordinatorEndOfTrialExtensionQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
